export default __webpack_public_path__ + "static/media/onedrive.654669a2.svg";